import BaseObjectModelEntry from "./baseObjectModelEntry";
import IRepo from "../../interfaces/repo";
import Repo from "../../state/modules/repo";
import ObjectModelEntryProvider from "../../providers/objectModelEntryProvider";

export default class ObjectModelFakeEntry extends BaseObjectModelEntry {
  static repo: IRepo<ObjectModelFakeEntry, ObjectModelEntryProvider> = new Repo<ObjectModelFakeEntry, ObjectModelEntryProvider>('objectModelFakeEntries', ObjectModelFakeEntry, {}, new ObjectModelEntryProvider(ObjectModelFakeEntry, 'entry', 'entries', true));

  static get provider(): ObjectModelEntryProvider {
    return this.repo.provider;
  }

  static get displayName(): string {
    return 'Fake Entry';
  }
}
